import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { useLinksByUserLocale } from '@phoenix/core/frontend/shared/feature/global-links/use-links-by-user-locale';

import { useGetEventsQuery } from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { useQueryContextMemo } from '@phoenix/team-m/dashboard/frontend/shared/use-query-context-memo';
import { OverviewSubsection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-subsection';
import { TimberSportsTeaser } from '@phoenix/team-m/dashboard/frontend/ui/interesting-for-you/timbersports-teaser';
import {
  TimberSportsEvent,
  TimberSportsEvents as TimberSportsEventsComponent,
} from '@phoenix/team-m/dashboard/frontend/ui/interesting-for-you/timbersports-events';

export const TimberSportsEvents: FC = () => {
  const { t } = useTranslation();
  const {
    auth: { user },
  } = useCore();
  const { 'timbersports-events': flagEnabled } = useFlags();

  const { data: links } = useLinksByUserLocale(['timbersports_url']);

  const [{ data }] = useGetEventsQuery({
    variables: {
      limit: 15,
      country: user?.country,
    },
    pause: !user || !flagEnabled,
    context: useQueryContextMemo(),
  });

  const events = (data?.events?.timberSports?.items || []).filter((event) => !!event) as TimberSportsEvent[];

  return flagEnabled ? (
    <OverviewSubsection headline={t('dashboard_events_headline')} dataTestId="stihl-events-subsection">
      {links && <TimberSportsTeaser link={links?.['timbersports_url']} text={t('dashboard_events_paragraph_timbersports')} />}
      <TimberSportsEventsComponent events={events} />
    </OverviewSubsection>
  ) : null;
};
